/**
 * Feature Flags Configuration
 *
 * Feature flags are read from environment variables at build time.
 * Set in .env.development, .env.staging, or .env.production files.
 *
 * Example:
 *   REACT_APP_ENABLE_V2_PERSON_DASHBOARD=true
 *   REACT_APP_ENABLE_VIDEO_RECORDING=true
 */

// Helper to parse boolean env vars (defaults to fallback if not set)
const parseEnvBool = (value, fallback) => {
  if (value === undefined || value === null || value === "") {
    return fallback;
  }
  return value === "true";
};

export const FEATURE_FLAGS = {
  /**
   * V2 Person Dashboard
   * - Shows 5 sections: Risk Insights, Exercise Modules, Vitals, Activity, Care Plan
   * - Only TUG Front and TUG Side are visible in Exercise Modules
   */
  ENABLE_V2_PERSON_DASHBOARD: parseEnvBool(
    process.env.REACT_APP_ENABLE_V2_PERSON_DASHBOARD,
    true,
  ),

  /**
   * Video Recording Feature
   * - Shows Record/Upload choice modal for TUG Front and TUG Side
   * - Allows recording video directly from the browser
   */
  ENABLE_VIDEO_RECORDING: parseEnvBool(
    process.env.REACT_APP_ENABLE_VIDEO_RECORDING,
    true,
  ),

  /**
   * V2 Care Plan
   * - Redesigned care plan with role selector, collapsible accordion sections,
   *   urgency banner, and per-role care action block
   */
  ENABLE_V2_CARE_PLAN: parseEnvBool(
    process.env.REACT_APP_ENABLE_V2_CARE_PLAN,
    true,
  ),

  /** Keep generated vitals values out of production unless explicitly enabled for demos. */
  ENABLE_VITALS_DEMO: parseEnvBool(
    process.env.REACT_APP_ENABLE_VITALS_DEMO,
    false,
  ),
};

export default FEATURE_FLAGS;
